import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col md:flex-row" }
const _hoisted_2 = { class: "flex-1 flex flex-col py-4 px-8 bg-white" }
const _hoisted_3 = { class: "flex items-start justify-between animate-slideFadeIn" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "md:hidden" }
const _hoisted_6 = { class: "flex-1 flex items-center justify-center w-full max-w-lg mx-auto" }
const _hoisted_7 = { class: "animate-slideFadeIn transition-all duration-300 hidden md:flex flex-1 flex-col justify-between p-8 pl-14 text-white rounded-l-[50px] relative overflow-hidden shadow-2xl" }
const _hoisted_8 = { class: "relative flex flex-col h-full justify-between z-10" }
const _hoisted_9 = { class: "flex flex-row items-center justify-between animate-slideFadeIn transition-all delay-1000" }

import AuthFaqPopover from "@/components/auth/AuthFaqPopover.vue";
import { CircleQuestionMark } from "lucide-vue-next";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('../assets/logo.svg'),
          class: "w-[85px] h-auto -ml-3",
          alt: "Logo"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AuthFaqPopover)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-tr from-purple-500 via-pink-500 to-indigo-500 bg-[length:400%_400%] animate-gradient-move rounded-l-[50px]" }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-white/10 via-blue-600/20 to-white/10 rounded-l-[50px] pointer-events-none animate-pulse-gradient" }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-0 backdrop-blur-sm bg-gradient-to-br from-pink-400 via-purple-600 to-indigo-400 bg-[length:400%_400%] animate-gradient-move animation-delay-2000ms rounded-l-[50px] opacity-30 pointer-events-none" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center justify-center gap-5" }, [
            _createElementVNode("h1", { class: "text-2xl font-bold text-white" }, "TAWA Digital Factory")
          ], -1)),
          _createElementVNode("div", null, [
            _createVNode(AuthFaqPopover)
          ])
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"mt-auto mb-5 animate-slideFadeIn transition-all delay-1000\"><h2 class=\"text-[40px] font-bold mb-2 w-64 leading-snug text-white\"><span class=\"block\">Collaborate,</span><span class=\"block\">Create &amp;</span><span class=\"block\">Grow.</span></h2><p class=\"text-sm max-w-lg pl-1 text-white/70 font-light\"> Designed to make collaboration simple, transparent, and effective. Where Creators build, grow, and earn through authentic partnerships. Brands launch campaigns with vetted creators and measurable outcomes. </p></div><footer class=\"text-xs opacity-70 text-center mt-6\"> © 2026 TAWA Digital Talents. All rights reserved. </footer>", 2))
      ])
    ])
  ]))
}
}

})